import { Component } from '@angular/core';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  imports: [PageHeaderComponent],
})
export class WelcomeComponent {}
